<template>
  <div>
    <div>
      <p>לאיזו חברה תרצו לשכפל את המשרה? <span v-if="company_selected" class="large_font_size"><b>{{company_selected.name}}</b></span></p>
      <input @input="searchCompany($event.target.value)" class="outlined" placeholder="לדוגמא... הרצוג">
      <div class="search_results">
        <p @click="chooseCompany(company)" v-for="company in results" :key="company.id" class="search_result">{{company.name}}</p>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading, faded: company_selected == undefined }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'duplicate-position',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      results: [],
      company_selected: undefined
    }
  },
  methods: {
    searchCompany (search_term) {
      this.$network_utils.searchCompany({ name: search_term }).then(response => {
        this.results = response
      })
    },
    chooseCompany (company) {
      this.company_selected = company
      this.results = []
    },
    submit () {
      this.is_loading = true
      this.$network_utils.duplicatePosition({ position_id: this.payload.data.id, new_company_id: this.company_selected.resource_id }).then(response => {
        this.is_loading = false
        this.openCreatePositionModal(response)
        this.remove(this.payload)
        this.$utils.emit('show_toast', { text: 'success' })
      })
    },
    openCreatePositionModal (new_position) {
      this.create({
        designator: 'create-position-step-three',
        component_name: 'CreatePositionStepThree',
        ignore_escape_button: true,
        position: new_position,
        modal_width: 900,
        company_id: this.company_selected.resource_id,
        modal_title: 'Position Duplicated - ' + new_position.title
      })
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
